export default __webpack_public_path__ + "static/media/code_jd_al_cxqjd.6017390b.png";